import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell, CheckCircle } from "@phosphor-icons/react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = async () => setItems((await api.get("/notifications")).data);
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="p-8 max-w-4xl">
      <div className="flex items-start justify-between mb-6">
        <div>
          <div className="text-xs uppercase tracking-[0.28em] text-neutral-500 dark:text-neutral-500 mb-2">Alerts</div>
          <h1 className="text-4xl font-semibold tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>Notifications</h1>
        </div>
        <button data-testid="notif-mark-all" onClick={markAll} className="text-sm px-4 py-2 rounded-md border border-neutral-300 dark:border-neutral-700 hover:bg-neutral-100 dark:hover:bg-neutral-800 flex items-center gap-2"><CheckCircle size={16} /> Mark all as read</button>
      </div>
      <div className="border border-neutral-200 dark:border-neutral-800 rounded-lg bg-white dark:bg-neutral-900 divide-y divide-neutral-100 dark:divide-neutral-800">
        {items.length === 0 ? (
          <div className="p-8 text-sm text-neutral-500 dark:text-neutral-500 text-center">All caught up.</div>
        ) : items.map((n) => (
          <div key={n.notification_id} className={`p-4 flex items-center gap-3 ${n.read ? "opacity-60" : ""}`}>
            <Bell size={16} className={n.read ? "text-neutral-400 dark:text-neutral-500" : "text-[#0F52BA]"} weight="duotone" />
            <div className="flex-1">
              <div className="text-sm font-medium">{n.title}</div>
              <div className="text-xs text-neutral-500 dark:text-neutral-500">{n.body}</div>
            </div>
            <div className="text-xs text-neutral-500 dark:text-neutral-500">{new Date(n.created_at).toLocaleString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
